module.exports = __webpack_public_path__ + "b62c8ca639b1bdb3bafc60d1d26d54da.svg";